import {Component} from '@angular/core';
import {MotInterdit} from '@domain/admin/parametre/authentification/mot-interdit';
import {ListViewItem} from "@domain/common/list-view/list-view-item";

/**
 * Composant d'affichage d'un item de la liste noire
 *
 * @author Lionel Gimenez
 * @date 26/08/2025
 */
@Component({
    host: {'data-test-id': 'liste-noire-item'},
    selector: 'liste-noire-item',
    templateUrl: './liste-noire-item.component.html'
})
export class ListeNoireItemComponent extends ListViewItem<MotInterdit> {
}
